module.exports = __webpack_public_path__ + "img/logo-mydeposys.5ffeb19e.png";